<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con">
<h2 class="contentsHead">Contents</h2>
<div class="contentsEntry">
<p class="contentsEntryNumber"><a href="#/xhtml/epigraph#epi01">Epigraph</a></p></div>
<div class="contentsEntry" id="ch_01">
<p class="contentsEntryNumber"><a href="#/xhtml/chapter01#ch01">One</a></p>
<p class="contentsEntryName">In Brooklyn, in a part of Brooklyn that was the…</p>
</div>
<div class="contentsEntry" id="ch_02">
<p class="contentsEntryNumber"><a href="#/xhtml/chapter02#ch02">Two</a></p>
<p class="contentsEntryName">Third period of the school day, Valentine took her seat…</p>
</div>
<div class="contentsEntry" id="ch_03">
<p class="contentsEntryNumber"><a href="#/xhtml/chapter03#ch03">Three</a></p>
<p class="contentsEntryName">Over the traditional Sunday-morning meal, a table laden with the…</p>
</div>
<div class="contentsEntry" id="ch_04">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter04#ch04" title="Link target outside of Sample">Four</span></p>
<p class="contentsEntryName">When Valentine stopped running, she found herself back at the…</p>
</div>
<div class="contentsEntry" id="ch_05">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter05#ch05" title="Link target outside of Sample">Five</span></p>
<p class="contentsEntryName">Literally overnight the weather turned from cold to a freezing…</p>
</div>
<div class="contentsEntry" id="ch_06">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter06#ch06" title="Link target outside of Sample">Six</span></p>
<p class="contentsEntryName">The sun set and Valentine lit the candles to commemorate…</p>
</div>
<div class="contentsEntry" id="ch_07">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter07#ch07" title="Link target outside of Sample">Seven</span></p>
<p class="contentsEntryName">Decidedly peeved about having to work the day after Christmas—It’s…</p>
</div>
<div class="contentsEntry" id="ch_08">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter08#ch08" title="Link target outside of Sample">Eight</span></p>
<p class="contentsEntryName">It was that darkest of hours, no sign of the…</p>
</div>
<div class="contentsEntry" id="ch_09">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter09#ch09" title="Link target outside of Sample">Nine</span></p>
<p class="contentsEntryName">During the week which began with the Purification of the…</p>
</div>
<div class="contentsEntry" id="ch_10">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Ten</span></p>
<p class="contentsEntryName">In this year, as it happened, Valentine’s Day fell on…</p>
</div>
<div class="contentsEntry" id="ch_11">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Eleven</span></p>
<p class="contentsEntryName">All that remained for Joanne Clarke to do was slip…</p>
</div>
<div class="contentsEntry" id="ch_12">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Twelve</span></p>
<p class="contentsEntryName">Calling in sick that Monday was an option, but when…</p>
</div>
<div class="contentsEntry" id="ch_13">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Thirteen</span></p>
<p class="contentsEntryName">On the afternoon of the first night of Passover, while…</p>
</div>
<div class="contentsEntry" id="ch_14">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">Fourteen</span></p>
<p class="contentsEntryName">A cold and wet April was followed by a cold…</p>
</div>
<div class="contentsEntry" id="ch_15">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Fifteen</span></p>
<p class="contentsEntryName">Valentine took the chair beside Miss Marks, and Dr. Stern…</p>
</div>
<div class="contentsEntry" id="ch_16">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Sixteen</span></p>
<p class="contentsEntryName">The way Adam begat Seth and Seth begat Enos and…</p>
</div>
<div class="contentsEntry" id="ch_17">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">Seventeen</span></p>
<p class="contentsEntryName">Miriam tapped her teeth with the eraser end of her…</p>
</div>
<div class="contentsEntry" id="ch_18">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">Eighteen</span></p>
<p class="contentsEntryName">A long with end-of-term forms to fill out, grade sheets…</p>
</div>
<div class="contentsEntry" id="ch_19">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">Nineteen</span></p>
<p class="contentsEntryName">Summer days somehow operate on a different equation for time…</p>
</div>
<div class="contentsEntry" id="ch_20">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">Twenty</span></p>
<p class="contentsEntryName">Summer, with its way of lazing along, as if it…</p>
</div>
<div class="contentsEntry" id="ch_21">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">Twenty-One</span></p>
<p class="contentsEntryName">As the gourds and pumpkins that would soon decorate porch…</p>
</div>
<div class="contentsEntry" id="ch_22">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample">Twenty-Two</span></p>
<p class="contentsEntryName">Shortly before the game was due to break up for…</p>
</div>
<div class="contentsEntry" id="ch_23">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample">Twenty-Three</span></p>
<p class="contentsEntryName">The light of dawn blanketed the bed, swathing across Valentine…</p>
</div>
<div class="contentsEntry" id="ch_24">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample">Twenty-Four</span></p>
<p class="contentsEntryName">Cardboard cutouts of Santa Claus and elves and giant candy…</p>
</div>
<div class="contentsEntry" id="ch_25">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter25#ch25" title="Link target outside of Sample">Twenty-Five</span></p>
<p class="contentsEntryName">By the dozens, maybe the hundreds, maybe more, they came.</p>
</div>
<div class="contentsEntry" id="ch_26">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter26#ch26" title="Link target outside of Sample">Twenty-Six</span></p>
<p class="contentsEntryName">With one shopping day until Christmas remaining, the stores were…</p>
</div>
<div class="contentsEntry" id="ack_01">
<p class="contentsEntryName"><span href="#/xhtml/acknowledgments#ack01" title="Link target outside of Sample">Acknowledgments</span></p>
</div>
<div class="contentsEntry" id="ata_01">
<p class="contentsEntryName"><span href="#/xhtml/abouttheauthor#ata01" title="Link target outside of Sample">About the Author</span></p>
</div>
<div class="contentsEntry" id="rev_01">
<p class="contentsEntryName"><span href="#/xhtml/praise#rev01" title="Link target outside of Sample">Praise</span></p>
</div>
<div class="contentsEntry" id="adc_01">
<p class="contentsEntryName"><span href="#/xhtml/otherbooks#adc01" title="Link target outside of Sample">Also by Binnie Kirshenbaum</span></p>
</div>
<div class="contentsEntry" id="cop_01">
<p class="contentsEntryName"><span href="#/xhtml/copyright#cop01" title="Link target outside of Sample">Copyright</span></p>
</div>
<div class="contentsEntry" id="atp_01">
<p class="contentsEntryName"><span href="#/xhtml/aboutthepublisher#atp01" title="Link target outside of Sample">About the Publisher</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?63e0cade